/************************************
 MODULE:         Language Selector
 WHAT IT DOES:   initiate instances of language selector
 *************************************/
 (function (root, factory) {
  if (typeof define === 'function' && define.amd) {
      define(['jquery'], factory);
  }
  else if (typeof exports === 'object') {
      module.exports = factory(require('jquery'));
  }
  else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {


  function init() {
      var instances = [];
      var $elements = $('.js-page-header-bg:not(.js-page-header-bg-inited)');

      if (!$elements.length) {
          return;
      }


      require.ensure([], function () {
          var PageHeaderBg = require('./page-header-bg');

          $elements.each(function(i, element) {
              instances.push(new PageHeaderBg(element));
              element.classList.add('js-page-header-bg-inited');
          });
      }, 'page-header-bg');


  }

  return {
      init: init
  };

}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/page-header-bg/app.page-header-bg.js
 ** module id = 73
 ** module chunks = 24
 **/